import { render, staticRenderFns } from "./zxtjDetail.vue?vue&type=template&id=bd30a1bc&scoped=true"
import script from "./zxtjDetail.vue?vue&type=script&lang=js"
export * from "./zxtjDetail.vue?vue&type=script&lang=js"
import style0 from "./zxtjDetail.vue?vue&type=style&index=0&id=bd30a1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd30a1bc",
  null
  
)

export default component.exports